// extracted by mini-css-extract-plugin
module.exports = {"Search":"locationNew_Search__BoYTK","Citys":"locationNew_Citys__O8f3z","Title":"locationNew_Title__oPHdd","Close":"locationNew_Close__GKPtj"};